import { useMemo } from 'react';

import { PARTNER_TASK_CARDS } from '#client/components/PartnerDash/PartnerNextUp/constants';
import { useOrderTrackerStatus } from '#client/hooks/useOrderTrackerStatus';

const SEQUENCE = ['llc_formation', 'change_of_registered_agent', 'ein_creation'];
const NO_ACTION_NEEDED_STATUSES = ['complete', 'active', 'declined', 'cancelled', 'pending', 'processing'];

function usePartnerNextUp() {
  const { loading, orderTasksWithStatus } = useOrderTrackerStatus();

  const cards = useMemo(() => {
    if (loading) {
      return [];
    }

    const taskMap = orderTasksWithStatus.reduce((acc, task) => {
      acc[task.type] = task;
      return acc;
    }, {});

    const activeIndex = SEQUENCE.findIndex((type) => {
      const task = taskMap[type];
      return !task || !NO_ACTION_NEEDED_STATUSES.includes(task.status);
    });

    if (activeIndex === -1) {
      return [];
    }

    return SEQUENCE.slice(activeIndex).map((type, idx) => ({
      type,
      isLocked: idx > 0,
      ...PARTNER_TASK_CARDS[type]
    }));
  }, [loading, orderTasksWithStatus]);

  return { cards, loading };
}

export default usePartnerNextUp;
